import { Component, ViewEncapsulation, OnInit, ViewChild, ViewContainerRef, ElementRef, ComponentRef, HostListener } from '@angular/core';

import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1400Model } from './kymw1400.model';
import { KYMW1404Model } from '../kymw1404/kymw1404.model';
import { KYMW1400KomaPageModel } from './kymw1400-koma-page/kymw1400-koma-page.model';
import { KYMW0900InputModel } from '../../../commons/kymw09/kymw0900/vo/kymw0900-input.model';
import { KYMW1406InputModel } from '../kymw1406/vo/kymw1406-input.model';
import { KYMW1409InputModel } from '../kymw1409/vo/kymw1409-input.model';

import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { PlessHttp } from '../../../shared/http/pless-http.service';

import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';

import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { VMediumTypeComboBoxComponent } from '../../../commons/kymw02/combo-box/vmedium-type-combo-box/vmedium-type-combo-box.component';

import { KYMW0800Component } from '../../../commons/kymw08/kymw0800/kymw0800.component';
import { KYMW0900Component } from '../../../commons/kymw09/kymw0900/kymw0900.component';
import { KYMW0A00Component } from '../../../commons/kymw0a/kymw0a00/kymw0a00.component';
import { KYMW1400KomaPageLeftComponent } from './kymw1400-koma-page-left/kymw1400-koma-page-left.component';
import { KYMW1400KomaPageRightComponent } from './kymw1400-koma-page-right/kymw1400-koma-page-right.component';
import { KYMW1402Component } from '../kymw1402/kymw1402.component';
import { KYMW1403Component } from '../kymw1403/kymw1403.component';
import { KYMW1404Component } from '../kymw1404/kymw1404.component';
import { KYMW1406Component } from '../kymw1406/kymw1406.component';
import { KYMW1407Component } from '../kymw1407/kymw1407.component';
import { KYMW1409Component } from '../kymw1409/kymw1409.component';

import { KYMW0800OutputModel } from '../../../commons/kymw08/kymw0800/vo/kymw0800-output.model';
import { KYMW0900OutputModel } from '../../../commons/kymw09/kymw0900/vo/kymw0900-output.model';
import { KYMW0A00OutputModel } from '../../../commons/kymw0a/kymw0a00/vo/kymw0a00-output.model';
import { KYMW1404OutPutModel } from '../kymw1404/vo/kymw1404-output.model';
import { KYMW1403OutputModel } from '../kymw1403/vo/kymw1403-output.model';
import { KYMW1406OutputModel } from '../kymw1406/vo/kymw1406-output.model';
import { KYMW1409OutputModel } from '../kymw1409/vo/kymw1409-output.model';
import { PageIDModel } from './vo/page-id.model';
import { NvalInputModel } from '../../../commons/kymw0a/kymw0a00/vo/nval-input.model';

import { DeleteAllKomaService } from './api-services/delete-all-koma.service';
import { DeleteKomaService } from './api-services/delete-koma.service';
import { GetKomaService } from './api-services/get-koma.service';
import { RegistGoodsService } from './api-services/regist-goods.service';
import { PageLockService } from '../../../commons/kymw00/api-services/page-lock.service';
import { PlanGoodsLockService } from '../../../commons/kymw00/api-services/plan-goods-lock.service';
import { KYMW1400KomaPageComponent } from './kymw1400-koma-page/kymw1400-koma-page.component';
import { FMenu } from 'src/app/commons/kymw02/function-menu/fmenu';
import { FunctionMenuService } from 'src/app/commons/kymw02/function-menu/function-menu.service';
import { CanDeactivateType } from 'src/app/shared/utils/leave-confirm.guard';
import { KYMW1422Component } from '../kymw1422/kymw1422.component';
import { KYMW2000InputModel } from '../../kymw20/kymw2000/vo/kymw2000-input.model';
import { KYMW2000Component } from '../../kymw20/kymw2000/kymw2000.component';

/**
 * コマ割画面を管理するクラス
 *
 * @export KYMW1400Component
 * @class KYMW1400Component
 */
@Component({
  selector: 'app-kymw1400',
  templateUrl: 'kymw1400.component.html',
  styleUrls: ['kymw1400.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: PlanGoodsLockService,
      useFactory: (plessHttp: PlessHttp, dialogService: PlessDialogServiceSub) => new PlanGoodsLockService(plessHttp, dialogService),
      deps: [PlessHttp, PlessDialogServiceSub]
    },
    {
      provide: PageLockService,
      useFactory: (plessHttp: PlessHttp, dialogService: PlessDialogServiceSub) => new PageLockService(plessHttp, dialogService),
      deps: [PlessHttp, PlessDialogServiceSub]
    },

  ]
})
export class KYMW1400Component extends PlessViewHelperSub implements OnInit {
  @ViewChild('txi_OrderCode', { static: true }) txi_OrderCode: OrderCodeTextInputComponent;
  @ViewChild('cmb_Medium', { static: true }) cmb_Medium: VMediumTypeComboBoxComponent;

  @ViewChild('pv_PageViewLeft', { static: true }) pv_PageViewLeft: KYMW1400KomaPageLeftComponent;
  @ViewChild('pv_PageViewRight', { static: true }) pv_PageViewRight: KYMW1400KomaPageRightComponent;

  // チェックボックス・ラジオボタン用エレメント取得
  private radioSingle: HTMLInputElement = null;
  private radioDouble: HTMLInputElement = null;
  private komaImageView: HTMLInputElement = null;
  private komaStringView: HTMLInputElement = null;

  // 実績履歴画面表示
  private kymw0800ComponentRef: ComponentRef<any> = null;
  private kymw0800Component: KYMW0800Component = null;
  // 掲載商品検索画面表示
  private kymw0A00Component: KYMW0A00Component = null;
  private kymw1403ComponentRef: ComponentRef<any> = null;
  private kymw1403Component: KYMW1403Component = null;
  // 掲載候補商品リスト画面表示
  private kymw1404ComponentRef: ComponentRef<any> = null;
  private kymw1404Component: KYMW1404Component = null;
  private kymw1404ModelParent: KYMW1404Model = new KYMW1404Model();
  // 商品情報画面表示
  private kymw1406ComponentRef: ComponentRef<any> = null;
  private kymw1406Component: KYMW1406Component = null;
  // 使用画像指示画面表示
  private kymw1407ComponentRef: ComponentRef<any> = null;
  private kymw1407Component: KYMW1407Component = null;
  // マーク指示画面表示
  private kymw1409Component: KYMW1409Component = null;
  private kymw1409ComponentRef: ComponentRef<any> = null;

  // 業態区分(1:ウィークリー)
  private readonly DUTIES_FORM_DIV_WEEKLY: string = String('1');

  // ボタンスタイル
  private readonly BUTTON_STYLE_DEFAULT: string = String('default');
  private readonly BUTTON_STYLE_SELECTED: string = String('selected');

  // ボタンスタイル初期値
  public clsSinglePage: string = this.BUTTON_STYLE_DEFAULT;
  public clsDoublePage: string = this.BUTTON_STYLE_SELECTED;
  public clsImageVisible: string = this.BUTTON_STYLE_SELECTED;
  public clsTextVisible: string = this.BUTTON_STYLE_SELECTED;
  public clsCandidateGoods: string = this.BUTTON_STYLE_DEFAULT;
  public clsGoodsInfo: string = this.BUTTON_STYLE_DEFAULT;
  public clsImageDirection: string = this.BUTTON_STYLE_DEFAULT;
  public clsHistory: string = this.BUTTON_STYLE_DEFAULT;
  public clsMarkDirection: string = this.BUTTON_STYLE_DEFAULT;

  public styleToolTipLeft = Number(0);

  /**
   * ウィンドウ内のクリック・右クリック時にイベントを追加
   *
   * @param {*} event
   * @memberof KYMW1400Component
   */
  @HostListener('click', ['$event'])
  @HostListener('contextmenu', ['$event'])
  private onClickOut(event: Event): void {
    // モードレスのコンテキストメニューを非表示
    this.modelessContextmenuClose();
  }


  /**
   *Creates an instance of KYMW1400Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {ViewContainerRef} viewContainerRef
   * @param {KYMW00Model} kymw00Model
   * @param {KYMW1400Model} kymw1400Model
   * @param {DeleteAllKomaService} deleteAllKomaService
   * @param {DeleteKomaService} deleteKomaService
   * @param {GetKomaService} getKomaService
   * @param {RegistGoodsService} registGoodsService
   * @param {PageLockService} pageLockServiceSub
   * @param {PlanGoodsLockService} planGoodsLockServiceSub
   * @memberof KYMW1400Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private viewContainerRef: ViewContainerRef,
    private elementRef: ElementRef,
    private kymw00Model: KYMW00Model,
    public kymw1400Model: KYMW1400Model,
    private deleteAllKomaService: DeleteAllKomaService,
    private deleteKomaService: DeleteKomaService,
    private getKomaService: GetKomaService,
    private registGoodsService: RegistGoodsService,
    private pageLockServiceSub: PageLockService,
    private planGoodsLockServiceSub: PlanGoodsLockService,
    private fmenuService: FunctionMenuService
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1400Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1400';
    this.pageLockService = this.pageLockServiceSub;
    this.planGoodsLockService = this.planGoodsLockServiceSub;
    // モデルクラスへ自コンポーネントを連携
    this.kymw1400Model.kymw1400Component = this;
    this.kymw1400Model.leftView = this.pv_PageViewLeft.KYMW1400KomaPageLeftViewHelper;
    this.kymw1400Model.rightView = this.pv_PageViewRight.KYMW1400KomaPageRightViewHelper;
    // 0：使用不可、1：閲覧のみ、2：フルコントロール可能（帳票出力、更新）
    this.kymw1400Model.funcPermission = this.getFuncPermission();

    // 画面の活性/非活性制御を行う
    this.kymw1400Model.updateMenuAndButtonEnable();

    // メニュー初期設定
    this.initMenuBar();

    // 見開き表示
    this.eventDoublePage_CLICKHandler();

    // 初期表示時の初回フォーカス位置
    this.txi_OrderCode.inputText.nativeElement.focus();
  }

  /**
   * メニュー初期化処理
   *
   * @private
   * @memberof KYMW1400Component
   */
  private initMenuBar(): void {
    // ［ファイル］メニューを作成します
    const menuFile = new FMenu('#menuFile', {
      header: 'ファイル',
      displayMemberPath: 'header',
      subItemsPath: 'items',
      selectedValuePath: 'menuID',
      dropDownCssClass: 'menubar-items',
      openOnHover: false,
      isAnimated: true,
      itemsSource: [
        { header: '閉じる', menuID: 'mi_Close' },
        { header: '印刷', menuID: 'mi_Print' },
      ],
      command: this.getFormatMenuCommand(),
      // イベント設定
      itemClicked: () => {
        this.eventMnbMenu_ITEM_CLICKHandler(menuFile);
      }
    });
    //menuFile.inputElement.tabIndex = -1;

    // ［編集］メニューを作成します
    const menuEdit = new FMenu('#menuEdit', {
      header: '編集',
      displayMemberPath: 'header',
      subItemsPath: 'items',
      selectedValuePath: 'menuID',
      dropDownCssClass: 'menubar-items',
      openOnHover: false,
      isAnimated: true,
      itemsSource: [
        { header: '掲載商品検索', menuID: 'mi_KYMW1403' },
        { header: '選定済商品数一覧', menuID: 'mi_KYMW2000' },
        { header: '選択コマ削除', menuID: 'mi_SelectedKomaDelete' },
        { header: '全コマ削除', menuID: 'mi_AllKomaDelete' },
      ],
      command: this.getFormatMenuCommand(),
      // イベント設定
      itemClicked: () => {
        this.eventMnbMenu_ITEM_CLICKHandler(menuEdit);
      }
    });

    // ［表示］メニューを作成します
    const menuDisp = new FMenu('#menuDisp', {
      header: '表示',
      displayMemberPath: 'header',
      subItemsPath: 'items',
      selectedValuePath: 'menuID',
      dropDownCssClass: 'menubar-items',
      openOnHover: false,
      isAnimated: true,
      itemsSource: [
        { header: '単ページ表示', menuID: 'mi_SinglePageView', invert: false },
        { header: '見開き表示', menuID: 'mi_DoublePageView', invert: true },
        { header: 'コマに画像', menuID: 'mi_KomaImageView', invert: this.kymw1400Model.komaImageViewFlg },
        { header: 'コマに文字情報', menuID: 'mi_KomaStringView', invert: this.kymw1400Model.komaTextViewFlg },
        { header: '掲載候補リスト', menuID: 'mi_KYMW1404' },
        { header: '商品情報', menuID: 'mi_KYMW1406' },
        { header: '画像指示', menuID: 'mi_KYMW1407' },
        { header: 'マーク指示', menuID: 'mi_KYMW1409' },
        { header: '実績履歴', menuID: 'mi_KYMW0800' },
      ],
      command: this.getFormatMenuCommand(),
      // イベント設定
      itemClicked: () => {
        this.eventMnbMenu_ITEM_CLICKHandler(menuDisp);
      }
    });

    this.fmenuService.menus = [menuFile, menuEdit, menuDisp];
  }

  updateMenuBar(): void {
    this.fmenuService.menus[1].itemSources[2].enabled = !this.kymw1400Model.disabledDeleteKomaFlg;
    this.fmenuService.menus[1].itemSources[3].enabled = !this.kymw1400Model.disabledDeleteAllKomaFlg;
  }

  /**
   * メニュー項目活性・非活性制御
   *
   * @private
   * @returns
   * @memberof KYMW1400Component
   */
  private getFormatMenuCommand(): any {
    return {
      canExecuteCommand: (param) => {
        // 各項目の活性制御
        switch (param.menuID) {
          case 'mi_Close':
            return !this.kymw1400Model.disabledCloseFlg;
          case 'mi_SelectedKomaDelete':
            return !this.kymw1400Model.disabledDeleteKomaFlg;
          case 'mi_AllKomaDelete':
            return !this.kymw1400Model.disabledDeleteAllKomaFlg;
          case 'mi_KYMW0800':
            return !this.kymw1400Model.disabledHistoryFlg;
          default:
            return true;
        }
      }
    };
  }

  /**
   * ページ編集領域変更時
   *
   * @memberof KYMW1400Component
   */
  public bindLeftPageSelected_CHANGEHandler(): void {
    // 企画商品情報ロック解除処理
    this.releaseAllPlanGoodsLock();

    // モードレスでポップアップしている画面を再表示する。
    this.sendInputVOToAllPopupDialog();
  }

  /**
   * 選択コマID変更時
   *
   * @memberof KYMW1400Component
   */
  public bindSelectedKomaId_CHANGEHandler(): void {
    // 企画商品情報ロック解除処理
    this.releaseAllPlanGoodsLock();

    // モードレスでポップアップしている画面を再表示する。
    this.sendInputVOToAllPopupDialog();
  }

  /**
   * コマ画像表示ボタンクリック時
   *
   * @memberof KYMW1400Component
   */
  public eventBtnKomaImageVisible_CLICKHandler(): void {
    this.kymw1400Model.leftView.page.setKomaImageViewFlg();
    this.kymw1400Model.rightView.page.setKomaImageViewFlg();
  }

  /**
   * コマテキスト表示ボタンクリック時
   *
   * @memberof KYMW1400Component
   */
  public eventBtnKomaTextVisible_CLICKHandler(): void {
    this.kymw1400Model.leftView.page.setKomaTextViewFlg();
    this.kymw1400Model.rightView.page.setKomaTextViewFlg();
  }

  /**
   * 受注コード変更時
   *
   * @param {string} orderCode
   * @memberof KYMW1400Component
   */
  public bindSelectedOrderCode_CHANGEHandler(orderCode: string): void {
    // ページのロック情報を解除
    this.releaseAllPageLock();

    // フェーズ情報クリア
    this.kymw1400Model.leftView.clear(false);
    this.kymw1400Model.rightView.clear(false);

    this.kymw1400Model.leftView.cmb_Page.orderCode = orderCode;
    this.kymw1400Model.rightView.cmb_Page.orderCode = orderCode;

    // コマ操作区分を「コマ編集」に設定
    this.kymw1400Model.leftView.kymw1400KomaPageModel.resetKomaType();
    this.kymw1400Model.rightView.kymw1400KomaPageModel.resetKomaType();

    // 画面の活性/非活性制御を行う
    this.kymw1400Model.updateMenuAndButtonEnable();

    if (this.kymw1404Component) {
      // kymw1404：フィルタ・ソートを初期化
      this.kymw1404Component.kymw1404Model.filterStatus = '';
      this.kymw1404Component.kymw1404Model.sortStatus = null;
    }

    // モードレスでポップアップしている画面を再表示する。
    this.sendInputVOToAllPopupDialog();
  }

  /**
   * 媒体コンボボックス変更時
   *
   * @memberof KYMW1400Component
   */
  public eventCmbMedium_CHANGEHandler(): void {
    // ページのロック情報を解除
    this.releaseAllPageLock();

    this.kymw1400Model.leftView.clear(false);
    this.kymw1400Model.rightView.clear(false);

    this.kymw1400Model.leftView.cmb_Page.mediumType = this.kymw1400Model.selectedMediumType;
    this.kymw1400Model.rightView.cmb_Page.mediumType = this.kymw1400Model.selectedMediumType;

    // コマ操作区分を「コマ入替」に設定
    this.kymw1400Model.leftView.kymw1400KomaPageModel.resetKomaType();
    this.kymw1400Model.rightView.kymw1400KomaPageModel.resetKomaType();

    if (this.kymw1400Model.selectedMediumTypeClass === '1' && this.cmb_Medium.selectedReceiptEOrderCode.length === 0 &&
      this.txi_OrderCode.selectedOrderCode.length !== 0) {
      this.dialogService.openAlertGetMessage('E0254');

    }
    // 画面の活性/非活性制御を行う
    this.kymw1400Model.updateMenuAndButtonEnable();

    // モードレスでポップアップしている画面を再表示する。
    this.sendInputVOToAllPopupDialog();
  }

  /**
   * メニュー選択イベント処理
   *
   * @param {Menu} menu
   * @returns {void}
   * @memberof KYMW1400Component
   */
  public eventMnbMenu_ITEM_CLICKHandler(menu: FMenu): void {
    let componentRef: any = null;
    let instance: any = null;

    switch (menu.selectedItem.menuID) {
      /* ファイル */
      // 閉じる
      case 'mi_Close':

        // 「ページ」が選択されていない場合、処理を終了する。
        if (PlessViewUtilsSub.isEmpty(this.kymw1400Model.selectedPageId)) {
          return;
        }

        this.eventMnbMenu_ITEM_CLICKHandlerCloseSuccess();
        break;

      // 印刷
      case 'mi_Print':
        this.kymw1400Model.disabledCloseFlg = !this.kymw1400Model.disabledCloseFlg;
        this.eventBtnPagePrint_CLICKHandler();
        break;

      /* 編集 */
      // 掲載商品検索
      case 'mi_KYMW1403':
        // すでに表示されていた場合最前面に表示
        if (this.isOpened('KYMW1403')) {

        } else {
          this.kymw1403ComponentRef = this.dialogService.openModelessSub(
            this, KYMW1403Component,
            this.viewContainerRef, this.kymw1403ComponentRef, null, 0, '', true);
          if (this.kymw1403ComponentRef != null) {
            this.kymw1403Component = this.kymw1403ComponentRef.instance as KYMW1403Component;
            this.kymw1403Component.parent = this;
            this.kymw1403Component.setKYMW1403Parameter = (outputVO: KYMW1403OutputModel) => {
              this.setKYMW1403Parameter(outputVO);
            };

            // ウィンドウが閉じられる際の処理
            this.kymw1403Component.closeFunction = () => {
              this.kymw1403ComponentRef.destroy();
            };
          }

        }
        break;
      // 選定済商品数一覧
      case 'mi_KYMW2000':
        const kymw2000InputVO: KYMW2000InputModel = {
          funcID: 'KYMW1400',
          mediumType: this.kymw1400Model.mediumType,
          orderCode: this.kymw1400Model.orderCode
        };

        // 選定済商品数一覧画面(モーダル)を表示する。
        const kymw2000Ref = this.dialogService.openModal(KYMW2000Component);
        const kymw2000Instance = kymw2000Ref.componentInstance as KYMW2000Component;
        kymw2000Instance.parent = this;
        kymw2000Instance.setParams(kymw2000InputVO);
        kymw2000Instance.closeFunction = () => {
          kymw2000Ref.close();
        };
        break;
      // 選択コマ削除
      case 'mi_SelectedKomaDelete':
        this.eventDeleteKoma_CLICKHandler();
        break;
      // 全コマ削除
      case 'mi_AllKomaDelete':
        this.eventDeleteAllKoma_CLICKHandler();
        break;

      /* 表示 */
      // 単ページ表示
      case 'mi_SinglePageView':
        this.eventSinglePage_CLICKHandler();
        break;
      // 見開き表示
      case 'mi_DoublePageView':
        this.eventDoublePage_CLICKHandler();
        break;
      // コマに画像
      case 'mi_KomaImageView':
        this.eventkomaImageVisible_CLICKHandler();
        this.eventBtnKomaImageVisible_CLICKHandler();
        break;
      // コマに文字情報
      case 'mi_KomaStringView':
        this.eventKomaTextVisible_CLICKHandler();
        this.eventBtnKomaTextVisible_CLICKHandler();
        break;
      // 掲載候補リスト
      case 'mi_KYMW1404':
        this.eventCandidateGoods_CLICKHandler();
        break;
      // 商品情報
      case 'mi_KYMW1406':
        this.eventGoodsInfo_CLICKHandler();
        break;
      // 画像指示
      case 'mi_KYMW1407':
        this.eventImageDirection_CLICKHandler();
        break;
      // マーク指示
      case 'mi_KYMW1409':
        this.eventMarkDirection_CLICKHandler();
        break;
      // 実績履歴
      case 'mi_KYMW0800':
        this.eventHistory_CLICKHandler();
        break;

      default:
    }
  }

  /**
   * メニュー選択イベント処理閉じるボタン成功時実行メソッド
   *
   * @private
   * @memberof KYMW1400Component
   */
  private eventMnbMenu_ITEM_CLICKHandlerCloseSuccess(): void {
    // ページ初期化処理を行う
    this.kymw1400Model.selectedPageViewHelper.clear();
  }

  canDeactivate(): CanDeactivateType {
    // 企画商品情報ロック解除処理
    this.releaseAllPlanGoodsLock();

    // ページのロック情報を解除
    this.releaseAllPageLock();

    // モード制御
    this.sharedModel.kymw1001Model.formReadOnlyMode.set(this.popupView, false);
    this.sharedModel.kymw1001Model.formReadOnlyMode.set(this.kymw1400Model.leftView.popupView, false);
    this.sharedModel.kymw1001Model.formReadOnlyMode.set(this.kymw1400Model.rightView.popupView, false);

    return true;
  }

  /**
   * ①【印刷】ボタンをユーザーが押下した時に呼び出されるメソッド。
   *
   * @memberof KYMW1400Component
   */
  public eventBtnPagePrint_CLICKHandler(): void {
    // 『誌面印刷』画面を呼び出す。
    const componentRef = this.dialogService.openModal(KYMW1402Component);
    const instance = componentRef.componentInstance as KYMW1402Component;
    instance.parent = this;
    instance.iInputVOArray = this.kymw1400Model.getKYMW1402InputVO();
    instance.inputParameterSetting();
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * ③【コマ追加】
   *
   * @memberof KYMW1400Component
   */
  public eventAddEmptyKoma_CLICKHandler(): void {
    // 「ページレイアウト」の空き領域チェックを行う
    if (!this.kymw1400Model.selectedPage.addNewKoma()) {
      this.dialogService.openAlertGetMessage('E0155');
    }
  }

  /**
   * ④【コマ削除】1
   *
   * @returns {void}
   * @memberof KYMW1400Component
   */
  public eventDeleteKoma_CLICKHandler(): void {
    // 「コマレイアウト」が未選択の場合、メッセージを表示して処理を終了する。
    if (!this.kymw1400Model.selectedPage.isSelectedKoma()) {
      this.dialogService.openAlertGetMessage('E0148', ['コマ']);
      return;
    }

    // 削除確認のメッセージを表示する。「NO」が選択された場合は処理を終了する。
    this.dialogService.openAlertGetMessage(
      'Q0115',
      null,
      (closeDetail) => {
        this.eventDeleteKoma_CLOSEHandler(closeDetail);
      });
  }

  /**
   * 【コマ削除】2コマ削除アラートクローズHandler
   *
   * @private
   * @param {*} closeDetail メッセージ回答
   * @memberof KYMW1400Component
   */
  public eventDeleteKoma_CLOSEHandler(closeDetail: any): void {
    if (closeDetail === PlessAlert.Yes) {
      // コマ情報削除要求(/KYMW14/deleteKomaData.xml)をサーバに送信する。
      const vo = this.kymw1400Model.getDeleteKomaVO();
      this.deleteKomaService.execute(
        vo,
        () => {
          this.eventDeleteKoma_CLOSEHandlerSuccess();
        });
    }
  }

  /**
   * 【コマ削除】3
   *
   * @private
   * @memberof KYMW1400Component
   */
  private eventDeleteKoma_CLOSEHandlerSuccess(): void {
    // 通信成功の場合実行する
    this.kymw1400Model.selectedPage.deleteSelectedKoma();

    // コマ選択情報の削除
    this.kymw1400Model.selectedPage.setSelectedKoma('');
    this.kymw1400Model.selectedPage.clarSelectedKoma();

    // 計画値集計表（計画点数、金額(千円)、GPR、点単価）を再表示する。
    this.dispatchGetPlanSummaryTableEvent();

    // 更新フラグを「削除」に設定
    this.kymw1400Model.updateFlg = 2;

    // 初期化
    this.kymw1400Model.reloadPcodeList = null;

    // モードレスでポップアップしている画面を再表示する。
    this.sendInputVOToAllPopupDialog();
  }

  /**
   * ⑤【全コマ削除】1
   *
   * @memberof KYMW1400Component
   */
  public eventDeleteAllKoma_CLICKHandler(): void {
    // // 削除確認のメッセージを表示する。「NO」が選択された場合は処理を終了する。
    this.dialogService.openAlertGetMessage('Q0116',
      null,
      (closeDetail) => {
        this.eventDeleteAllKoma_YESHandler(closeDetail);
      });
  }

  /**
   * 【全コマ削除】2全コマ削除アラートクローズHandler
   *
   * @private
   * @param {*} closeDetail メッセージ回答
   * @memberof KYMW1400Component
   */
  public eventDeleteAllKoma_YESHandler(closeDetail: any): void {
    if (closeDetail === PlessAlert.Yes) {
      // 全コマ情報削除要求(/KYMW14/deleteAllKomaData.xml)をサーバに送信する。
      const vo = this.kymw1400Model.getDeleteKomaVO();
      this.deleteAllKomaService.execute(
        vo,
        () => {
          this.eventDeleteAllKoma_YESHandlerSuccess();
        });
    }
  }

  /**
   * 【全コマ削除】3全コマ削除アラートクローズHandler
   *
   * @private
   * @memberof KYMW1400Component
   */
  private eventDeleteAllKoma_YESHandlerSuccess(): void {
    // 通信成功の場合実行する
    this.kymw1400Model.selectedPage.deleteAllKoma();

    // コマ選択情報の削除
    this.kymw1400Model.selectedPage.setSelectedKoma('');
    this.kymw1400Model.selectedPage.clarSelectedKoma();

    // 計画値集計表（計画点数、金額(千円)、GPR、点単価）を再表示する。
    this.dispatchGetPlanSummaryTableEvent();

    // 更新フラグを「削除」に設定
    this.kymw1400Model.updateFlg = 2;

    // 初期化
    this.kymw1400Model.reloadPcodeList = null;

    // モードレスでポップアップしている画面を再表示する。
    this.sendInputVOToAllPopupDialog();
  }

  /**
   * ⑥【単ページ表示】
   *
   * @returns {void}
   * @memberof KYMW1400Component
   */
  public eventSinglePage_CLICKHandler(): void {
    // コマタイプ変更時のリセット処理
    this.pv_PageViewLeft.KYMW1400KomaPageLeftViewHelper.resetKomaTypeAction();
    this.pv_PageViewRight.KYMW1400KomaPageRightViewHelper.resetKomaTypeAction();

    // 左ページ選択
    if (this.kymw1400Model.leftPageSelected) {
      this.kymw1400Model.leftPageVisible = true;
      this.kymw1400Model.rightPageVisible = false;
    } else {
      this.kymw1400Model.leftPageVisible = false;
      this.kymw1400Model.rightPageVisible = true;
    }

    this.kymw1400Model.singlePageFlg = true;
    // ボタンの表示状態を制御する
    this.clsSinglePage = this.BUTTON_STYLE_SELECTED;
    this.clsDoublePage = this.BUTTON_STYLE_DEFAULT;

    this.fmenuService.menus[2].itemSources[0].invert = true;
    this.fmenuService.menus[2].itemSources[1].invert = false;
  }

  /**
   * ⑦【見開き表示】
   *
   * @returns {void}
   * @memberof KYMW1400Component
   */
  public eventDoublePage_CLICKHandler(): void {
    this.kymw1400Model.leftPageVisible = true;
    this.kymw1400Model.rightPageVisible = true;

    this.kymw1400Model.singlePageFlg = false;

    // ボタンの表示状態を制御する
    this.clsSinglePage = this.BUTTON_STYLE_DEFAULT;
    this.clsDoublePage = this.BUTTON_STYLE_SELECTED;

    this.fmenuService.menus[2].itemSources[0].invert = false;
    this.fmenuService.menus[2].itemSources[1].invert = true;
  }

  /**
   * ⑧【画像表示】
   *
   * @returns {void}
   * @memberof KYMW1400Component
   */
  public eventkomaImageVisible_CLICKHandler(): void {
    this.kymw1400Model.komaImageViewFlg = !this.kymw1400Model.komaImageViewFlg;
    // ボタンスタイル設定
    if (this.kymw1400Model.komaImageViewFlg) {
      this.clsImageVisible = this.BUTTON_STYLE_SELECTED;
    } else {
      this.clsImageVisible = this.BUTTON_STYLE_DEFAULT;
    }

    this.fmenuService.menus[2].itemSources[2].invert = this.kymw1400Model.komaImageViewFlg;
  }

  /**
   * ⑨【文字表示】
   *
   * @returns {void}
   * @memberof KYMW1400Component
   */
  public eventKomaTextVisible_CLICKHandler(): void {
    this.kymw1400Model.komaTextViewFlg = !this.kymw1400Model.komaTextViewFlg;
    // ボタンスタイル設定
    if (this.kymw1400Model.komaTextViewFlg) {
      this.clsTextVisible = this.BUTTON_STYLE_SELECTED;
    } else {
      this.clsTextVisible = this.BUTTON_STYLE_DEFAULT;
    }

    this.fmenuService.menus[2].itemSources[3].invert = this.kymw1400Model.komaTextViewFlg;
  }

  /**
   * ⑩【掲載候補リスト】
   *
   * @memberof KYMW1400Component
   */
  public eventCandidateGoods_CLICKHandler(): void {
    // コマ割りで更新・削除されていた場合は候補リストを再検索で呼び出す
    this.kymw1400Model.updateFlg = 0;

    this.clsCandidateGoods = this.BUTTON_STYLE_SELECTED;

    this.kymw1404ComponentRef = this.dialogService.openModelessSub(
      this, KYMW1404Component,
      this.viewContainerRef, this.kymw1404ComponentRef, this.kymw1400Model.getKYMW1404InputVO(true), 0, '', true);
    if (this.kymw1404ComponentRef != null) {
      this.kymw1404Component = this.kymw1404ComponentRef.instance as KYMW1404Component;
      this.kymw1404Component.kymw1404Model = this.kymw1404ModelParent;
      this.kymw1404Component.inputParameterSetting();
      this.kymw1404Component.parent = this;
      this.kymw1404Component.setKYMW1404Parameter = (outputVO: KYMW1404OutPutModel) => {
        this.setKYMW1404Parameter(outputVO);
      };

      // ウィンドウが閉じられる際の処理
      this.kymw1404Component.closeFunction = () => {
        this.kymw1404ComponentRef.destroy();
        this.kymw1404ModelParent = this.kymw1404Component.kymw1404Model;
        this.clsCandidateGoods = this.BUTTON_STYLE_DEFAULT;
      };
    }

  }

  /**
   * ⑪【商品情報】
   *
   * @memberof KYMW1400Component
   */
  public eventGoodsInfo_CLICKHandler(): void {
    const vo: KYMW1406InputModel = new KYMW1406InputModel();
    vo.komaID = 0;
    vo.orderCode = this.kymw1400Model.orderCode;
    vo.mediumType = this.kymw1400Model.mediumType;

    // コマ選択前の呼び出しに対応する為、コマが選択されている場合のみコマＩＤを設定
    if (this.kymw1400Model.selectedPageViewHelper.page.selectedKoma != null) {
      vo.komaID = Number(this.kymw1400Model.selectedPageViewHelper.page.selectedKoma.komaId);
      vo.pcodeList = this.kymw1400Model.selectedKoma.getPcodeList();
      // 選択されているコマの注文商品区分を設定する
      let komaFlg = Boolean(false);										// 通常商品フラグ
      let nvalKomaFlg = Boolean(false);										// 1物N価商品フラグ
      let nvalWpKomaFlg = Boolean(false);										// 1物N価Ｗ掲載商品フラグ
      vo.orderGoodsFlgKoma = this.kymw1400Model.selectedKomaOrderGoodsFlg;	// 注文商品区分他レイアウト情報取得
      // 注文商品区分編集
      // コマの商品の注文商品区分を調べて、コマの商品の注文商品区分を確定する
      for (let i = Number(0); vo.orderGoodsFlgKoma.length > i; i++) {
        // 注文商品区分 = 通常商品("01")
        if (vo.orderGoodsFlgKoma[i].OrderGoodsFlg === '01') {
          // 通常商品フラグ  = true
          komaFlg = true;
        } else if (vo.orderGoodsFlgKoma[i].OrderGoodsFlg === '02') {
          // 注文商品区分 = 1物N価商品("02")
          // 1物N価商品フラグ = true
          nvalKomaFlg = true;
        } else if (vo.orderGoodsFlgKoma[i].OrderGoodsFlg === '03') {
          // 注文商品区分 = 1物N価Ｗ掲載商品("03")
          // 1物N価Ｗ掲載商品フラグ = true
          nvalWpKomaFlg = true;
        }
      }
      // コマの注文商品区分を確定
      // "01"：通常商品、"02"：1物N価商品、"03"：1物N価W掲載商品、"99"：通常商品と1物N価W掲載商品のマルチコマ
      // 通常商品フラグのみ「true」
      if ((komaFlg) && (!nvalKomaFlg) && (!nvalWpKomaFlg)) {
        // 注文商品区分 = 通常商品("01")
        vo.orderGoodsFlg = '01';
      } else if ((nvalKomaFlg) && (!komaFlg) && (!nvalWpKomaFlg)) {
        // 1物N価商品フラグ のみ「true」
        // 注文商品区分 = 1物N価商品("02")
        vo.orderGoodsFlg = '02';
      } else if ((nvalWpKomaFlg) && (!komaFlg) && (!nvalKomaFlg)) {
        // 1物N価Ｗ掲載商品フラグのみ「true」
        // 注文商品区分 = 1物N価Ｗ掲載商品("03")
        vo.orderGoodsFlg = '03';
      } else {
        // 上記以外
        // 注文商品区分 = 通常商品といつ注Ｗ掲載のマルチコマ("99")
        vo.orderGoodsFlg = '99';
      }
    }
    // * 0:編集可、1:編集不可(ロック時)
    if (!this.kymw1400Model.selectedPageViewHelper.kymw1400KomaPageModel.pageLock) {
      // 編集可能モードの場合、ロックを取得
      let pcodeList: Array<any> = new Array<any>();
      if (this.kymw1400Model.selectedPageViewHelper.page.selectedKoma != null) {
        pcodeList = this.kymw1400Model.selectedPageViewHelper.page.selectedKoma.goods.pcodeList;
      }
      if (pcodeList.length > 0) {
        this.LockUtilForPlanGoods('REGIST'
          , this.txi_OrderCode.selectedOrderCode
          , this.cmb_Medium.selectedMediumType
          , pcodeList
          , () => {
            this.kymw1400Model.pcodeList = pcodeList;
            vo.editMode = '0';
            this.callGoodsInfoAfterLockProcess(vo);
          }
          , null
          , (param: any, result: any) => {
            vo.editMode = '1';
            this.callGoodsInfoAfterLockProcess(vo);
            let UserName = '';
            if (result.result.obj.UnlockedInfo.Catalog[0] != null) {
              UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.Catalog[0].UserName) + ']';
            } else if (result.result.obj.UnlockedInfo.Page[0] != null) {
              UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.Page[0].UserName) + ']';
            } else {
              UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.PlanGoods[0].UserName) + ']';
            }
            this.dialogService.openAlertGetMessage('E0141', [UserName]);
          }
          , null
          , false);
      } else {
        vo.editMode = '0';
        this.callGoodsInfoAfterLockProcess(vo);
      }
    } else {
      vo.editMode = '1';
      this.callGoodsInfoAfterLockProcess(vo);
    }
  }

  /**
   * 商品情報表示処理（ロック処理後）
   *
   * @private
   * @param {KYMW1406InputModel} vo パラメータ
   * @memberof KYMW1400Component
   */
  private callGoodsInfoAfterLockProcess(vo: KYMW1406InputModel): void {
    this.clsGoodsInfo = this.BUTTON_STYLE_SELECTED;

    this.kymw1406ComponentRef = this.dialogService.openModelessSub(
      this, KYMW1406Component,
      this.viewContainerRef, this.kymw1406ComponentRef, vo, 0, '', true);
    if (this.kymw1406ComponentRef != null) {
      this.kymw1406Component = this.kymw1406ComponentRef.instance as KYMW1406Component;
      this.kymw1406Component.inputParameterSetting();
      this.kymw1406Component.parent = this;
      this.kymw1406Component.setKYMW1406Parameter = (outputVO: KYMW1406OutputModel) => {
        this.setKYMW1406Parameter(outputVO);
      };

      // ウィンドウが閉じられる際の処理
      this.kymw1406Component.closeFunction = () => {
        this.kymw1406ComponentRef.destroy();
        this.closeGoodsInfo();
        this.clsGoodsInfo = this.BUTTON_STYLE_DEFAULT;
      };
    }
  }

  /**
   * 商品情報終了時処理
   *
   * @private
   * @memberof KYMW1400Component
   */
  private closeGoodsInfo(): void {
    // 他の企画商品ロックを使用していない画面が開かれていなければ、ロックを削除する
    if (!this.isOpened('KYMW1409')) {
      this.releaseAllPlanGoodsLock();
    }
  }

  /**
   * ⑫【使用画像指示】
   *
   * @memberof KYMW1400Component
   */
  public eventImageDirection_CLICKHandler(): void {
    // 『使用画像指示』画面を呼び出す。モードレスモード
    this.clsImageDirection = this.BUTTON_STYLE_SELECTED;

    this.kymw1407ComponentRef = this.dialogService.openModelessSub(
      this, KYMW1407Component,
      this.viewContainerRef, this.kymw1407ComponentRef, this.kymw1400Model.getKYMW1407InputVO(), 0, '', true);
    if (this.kymw1407ComponentRef != null) {
      this.kymw1407Component = this.kymw1407ComponentRef.instance as KYMW1407Component;
      this.kymw1407Component.parent = this;
      this.kymw1407Component.setKYMW1407Parameter = () => {
        this.setKYMW1407Parameter();
      };

      // ウィンドウが閉じられる際の処理
      this.kymw1407Component.closeFunction = () => {
        this.kymw1407ComponentRef.destroy();
        this.clsImageDirection = this.BUTTON_STYLE_DEFAULT;
      };
    }
  }

  /**
   * ⑬【実績履歴】
   *
   * @memberof KYMW1400Component
   */
  public eventHistory_CLICKHandler(): void {
    // 『実績履歴』画面を呼び出す。
    this.clsHistory = this.BUTTON_STYLE_SELECTED;

    this.kymw0800ComponentRef = this.dialogService.openModelessSub(this, KYMW0800Component,
      this.viewContainerRef, this.kymw0800ComponentRef, this.kymw1400Model.getKYMW0800InputVO(), null, '', true);
    if (this.kymw0800ComponentRef != null) {
      this.kymw0800Component = this.kymw0800ComponentRef.instance as KYMW0800Component;
      this.kymw0800Component.setInterfaceParam(this.kymw1400Model.getKYMW0800InputVO());
      this.kymw0800Component.parent = this;
      this.kymw0800Component.setKYMW0800Parameter = (outputVO: KYMW0800OutputModel) => this.setKYMW0800Parameter(outputVO);

      // ウィンドウが閉じられる際の処理
      this.kymw0800Component.closeFunction = () => {
        this.kymw0800ComponentRef.destroy();
        this.clsHistory = this.BUTTON_STYLE_DEFAULT;
      };
    }
  }

  /**
   * ⑭【マーク指示】
   *
   * @memberof KYMW1400Component
   */
  public eventMarkDirection_CLICKHandler(): void {
    const vo: KYMW1409InputModel = new KYMW1409InputModel();
    vo.orderCode = this.kymw1400Model.selectedOrderCode;
    vo.coopCode = this.kymw1400Model.selectedCoopCode;
    if (this.kymw1400Model.selectedKoma != null) {
      vo.pCodeList = this.kymw1400Model.selectedKoma.getPcodeList();

      // 注文商品区分を設定する
      vo.orderGoodsFlgKoma = this.kymw1400Model.selectedKomaOrderGoodsFlg;	// 注文商品区分他レイアウト情報取得
      let komaFlg = Boolean(false);										// 通常商品フラグ
      let nvalKomaFlg = Boolean(false);										// 1物N価商品フラグ
      let nvalWpKomaFlg = Boolean(false);										// 1物N価Ｗ掲載商品フラグ
      // 注文商品区分編集
      // コマの商品の注文商品区分を調べて、コマの商品の注文商品区分を確定する
      for (let i = Number(0); vo.orderGoodsFlgKoma.length > i; i++) {
        // 注文商品区分 = 通常商品("01")
        if (vo.orderGoodsFlgKoma[i].OrderGoodsFlg === '01') {
          // 通常商品フラグ  = true
          komaFlg = true;
        } else if (vo.orderGoodsFlgKoma[i].OrderGoodsFlg === '02') {
          // 注文商品区分 = 1物N価商品("02")
          // 1物N価商品フラグ = true
          nvalKomaFlg = true;
        } else if (vo.orderGoodsFlgKoma[i].OrderGoodsFlg === '03') {
          // 注文商品区分 = 1物N価Ｗ掲載商品("03")
          // 1物N価Ｗ掲載商品フラグ = true
          nvalWpKomaFlg = true;
        }
      }
      // コマの注文商品区分を確定
      // "01"：通常商品、"02"：1物N価商品、"03"：1物N価W掲載商品、"99"：通常商品と1物N価W掲載商品のマルチコマ
      // 通常商品フラグのみ「true」
      if ((komaFlg) && (!nvalKomaFlg) && (!nvalWpKomaFlg)) {
        // 注文商品区分 = 通常商品("01")
        vo.orderGoodsFlg = '01';
      } else if ((nvalKomaFlg) && (!komaFlg) && (!nvalWpKomaFlg)) {
        // 1物N価商品フラグ のみ「true」
        // 注文商品区分 = 1物N価商品("02")
        vo.orderGoodsFlg = '02';
      } else if ((nvalWpKomaFlg) && (!komaFlg) && (!nvalKomaFlg)) {
        // 1物N価Ｗ掲載商品フラグのみ「true」
        // 注文商品区分 = 1物N価Ｗ掲載商品("03")
        vo.orderGoodsFlg = '03';
      } else {
        // 上記以外
        // 注文商品区分 = 通常商品といつ注Ｗ掲載のマルチコマ("99")
        vo.orderGoodsFlg = '99';
      }
      // 通常注文商品以外の場合
      for (let l = Number(0); vo.orderGoodsFlgKoma.length > l; l++) {
        if (vo.orderGoodsFlgKoma[l].OrderGoodsFlg === '02' || vo.orderGoodsFlgKoma[l].OrderGoodsFlg === '03') {
          // ページ、セクション情報が存在
          if (this.kymw1400Model.selectedPageManage.pageData != null
            && this.kymw1400Model.selectedPageManage.pageData.SectionInfo != null) {
            // セクション情報が1件でもArrayとして扱う
            const sectionInfoList: Array<any> = this.kymw1400Model.selectedPageManage.pageData.SectionInfo;
            // セクション情報数分ループ
            for (let i = Number(0); sectionInfoList.length > i; i++) {
              // コマ情報が存在
              if (sectionInfoList[i].KomaInfo != null) {
                // コマ情報が1件でもArrayとして扱う
                const komaInfoList: Array<any> = sectionInfoList[i].KomaInfo;
                // コマ情報数分ループ
                for (let j = Number(0); komaInfoList.length > j; j++) {
                  // 選択されたコマのコマIDと一致した場合
                  if (komaInfoList[j].KomaID === this.kymw1400Model.selectedKomaId) {
                    // レイアウト情報が存在
                    if (komaInfoList[j].LayoutInfo != null) {
                      // レイアウト情報が1件でもArrayとして扱う
                      const layoutInfoList: Array<any> = komaInfoList[j].LayoutInfo;
                      // レイアウト情報数分ループ
                      for (let k = Number(0); layoutInfoList.length > k; k++) {
                        const nvalInput: NvalInputModel = new NvalInputModel();
                        nvalInput.receiptSOrderCode = layoutInfoList[k].ReceiptSOrderCode;
                        nvalInput.startOrderCode = layoutInfoList[k].StartOrderCode;
                        nvalInput.orderNum6Digits = layoutInfoList[k].OrderNum6Digits;
                        nvalInput.itemCode = layoutInfoList[k].ItemCode;
                        vo.NvalInputList.push(nvalInput);
                      }
                    }
                    break;
                  }
                }
              }
            }
          }
        }
      }
    }
    // * 0:編集可、1:編集不可(ロック時)
    if (!this.kymw1400Model.selectedPageManage.pageLock) {
      // 編集可能モードの場合、ロックを取得
      let pcodeList: Array<any> = new Array<any>();
      if (this.kymw1400Model.selectedPageViewHelper.page.selectedKoma != null) {
        pcodeList = this.kymw1400Model.selectedPageViewHelper.page.selectedKoma.goods.pcodeList;
      }
      if (pcodeList.length > 0) {
        this.LockUtilForPlanGoods('REGIST'
          , this.txi_OrderCode.selectedOrderCode
          , this.cmb_Medium.selectedMediumType
          , pcodeList
          , () => {
            this.kymw1400Model.pcodeList = pcodeList;
            vo.editMode = '0';
            this.callMarkDirectionAfterLockProcess(vo);
          }
          , null
          , (param: any, result: any) => {
            vo.editMode = '1';
            this.callMarkDirectionAfterLockProcess(vo);
            let UserName = '';
            if (result.result.obj.UnlockedInfo.Catalog[0] != null) {
              UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.Catalog[0].UserName) + ']';
            } else if (result.result.obj.UnlockedInfo.Page[0] != null) {
              UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.Page[0].UserName) + ']';
            } else {
              UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.PlanGoods[0].UserName) + ']';
            }
            this.dialogService.openAlertGetMessage('E0141', [UserName]);
          }
          , null
          , false);
      } else {
        vo.editMode = '0';
        this.callMarkDirectionAfterLockProcess(vo);
      }
    } else {
      vo.editMode = '1';
      this.callMarkDirectionAfterLockProcess(vo);
    }
  }

  /**
   * マーク指示表示処理（ロック処理後）
   *
   * @private
   * @param {KYMW1409InputModel} vo パラメータ
   * @memberof KYMW1400Component
   */
  private callMarkDirectionAfterLockProcess(vo: KYMW1409InputModel): void {
    this.clsMarkDirection = this.BUTTON_STYLE_SELECTED;
    this.kymw1409ComponentRef = this.dialogService.openModelessSub(
      this, KYMW1409Component,
      this.viewContainerRef, this.kymw1409ComponentRef, vo, 0, '', true);
    if (this.kymw1409ComponentRef != null) {
      this.kymw1409Component = this.kymw1409ComponentRef.instance as KYMW1409Component;
      this.kymw1409Component.inputParameterSetting();
      this.kymw1409Component.parent = this;
      this.kymw1409Component.setKYMW1409Parameter = (outputVO: KYMW1409OutputModel) => {
        this.setKYMW1409Parameter(outputVO);
      };

      // ウィンドウが閉じられる際の処理
      this.kymw1409Component.closeFunction = () => {
        this.kymw1409ComponentRef.destroy();
        this.closeMarkDirection();
        this.clsMarkDirection = this.BUTTON_STYLE_DEFAULT;
      };
    }
  }

  /**
   * マーク指示終了時処理
   *
   * @private
   * @memberof KYMW1400Component
   */
  private closeMarkDirection(): void {
    if (!this.isOpened('KYMW1406')) {
      this.releaseAllPlanGoodsLock();
    }
  }

  /**
   * モードレスでポップアップしている画面を再表示する。
   * （掲載候補商品リスト/商品情報/使用画像指示/マーク指示/実績履歴/組合員の声選択）
   *
   * @param {boolean} [kymw1404Flg=true] 掲載候補商品リストフラグ
   * @param {boolean} [kymw1406Flg=true] 商品情報フラグ
   * @param {boolean} [kymw1407Flg=true] 使用画像指示フラグ
   * @param {boolean} [kymw1409Flg=true] マーク指示フラグ
   * @param {boolean} [kymw0800Flg=true] 実績履歴フラグ
   * @param {boolean} [kymw0A00Flg=true] 組合員の声選択フラグ
   * @param {boolean} [releasePlanGoodsLockFlg=true] 企画商品情報ロックフラグ
   * @memberof KYMW1400Component
   */
  public sendInputVOToAllPopupDialog(kymw1404Flg = true, kymw1406Flg = true,
    kymw1407Flg = true, kymw1409Flg = true,
    kymw0800Flg = true, kymw0A00Flg = true, releasePlanGoodsLockFlg = true): void {
    // モードレスのコンテキストメニューを非表示
    this.modelessContextmenuClose();
    // 企画商品情報ロック解除処理
    if (releasePlanGoodsLockFlg) {
      let pcodeList: Array<any> = new Array<any>();
      let equalFlg = Boolean(false);

      // 削除対象のPコードリストが存在する場合
      if (this.kymw1400Model.pcodeList.length > 0) {
        // 登録対象のPコードリストが存在する場合かつ、編集ロックが編集モードかつ、受注コードが変わらない場合かつ、媒体が変わらない場合
        if (this.kymw1400Model.selectedKoma != null
          && this.kymw1400Model.selectedKoma.getPcodeList().length > 0
          && !this.kymw1400Model.selectedPageViewHelper.kymw1400KomaPageModel.pageLock
          && this.kymw1400Model.orderCode === this.txi_OrderCode.selectedOrderCode
          && this.kymw1400Model.mediumType === this.cmb_Medium.selectedMediumType) {
          for (let i = Number(0); i < this.kymw1400Model.pcodeList.length; i++) {
            // 削除対象のPコードリスト
            equalFlg = false;
            for (let j = Number(0); j < this.kymw1400Model.selectedKoma.getPcodeList().length; j++) {
              // 登録対象のPコードリスト
              // 削除対象Pコードと、登録対象Pコードがイコールの場合
              if (this.kymw1400Model.pcodeList[i] === this.kymw1400Model.selectedKoma.getPcodeList()[j]) {
                equalFlg = true;
                break;
              }
            }
            // 削除対象Pコードが、登録対象のPコードリストに存在しない場合
            if (!equalFlg) {
              // 削除対象Pコードをリストに保持
              pcodeList.push(this.kymw1400Model.pcodeList[i]);
            }
          }
        } else {
          // 削除対象Pコードをリストに保持
          pcodeList = this.kymw1400Model.pcodeList;
        }
        // 保持したPコードリストにて企画商品ロック情報削除要求を行う
        this.LockUtilForPlanGoods('RELEASE'
          , this.kymw1400Model.orderCode
          , this.kymw1400Model.mediumType
          , pcodeList
          , null
          , null
          , null
          , null
          , false
        );
      }
      this.kymw1400Model.orderCode = this.txi_OrderCode.selectedOrderCode;
      this.kymw1400Model.mediumType = this.cmb_Medium.selectedMediumType;
    }

    // 掲載候補商品リスト:KYMW1404
    if (kymw1404Flg) {
      // 更新後または削除後の場合、再検索を行う
      if (this.kymw1400Model.updateFlg !== 0) {
        // 表示中であればフラグを初期化。非表示の場合は次回の表示時に初期化。
        if (this.isOpened('KYMW1404')) {
          this.kymw1404Component.setInputVO(this.kymw1400Model.getKYMW1404InputVO(true));
          // 更新区分を初期化
          this.kymw1400Model.updateFlg = 0;
        }
      } else {
        if (this.isOpened('KYMW1404')) {
          this.kymw1404Component.setInputVO(this.kymw1400Model.getKYMW1404InputVO());
        }
      }
    }

    // 使用画像指示:KYMW1407
    if (kymw1407Flg) {
      if (this.isOpened('KYMW1407')) {
        this.kymw1407Component.setInputVO(this.kymw1400Model.getKYMW1407InputVO());
      }
    }

    // 実績履歴:KYMW0800
    if (kymw0800Flg) {
      if (this.isOpened('KYMW0800')) {
        this.kymw0800Component.setInputVO(this.kymw1400Model.getKYMW0800InputVO());
      }
    }

    // 組合員の声選択:KYMW0A00
    if (kymw0A00Flg) {
      if (this.isOpened('KYMW0A00')) {
        this.kymw0A00Component.inputVO = this.kymw1400Model.getKYMW0A00InputVO();
      }
    }

    // 企画商品ロックを必要とするサブ画面：KYMW1406、KYMW1409
    if (kymw1406Flg || kymw1409Flg) {
      this.registLockForSendInputVO(kymw1406Flg, kymw1409Flg);
    }

  }

  /**
   * 掲載候補リストにInputVO送信する
   *
   * @memberof KYMW1400Component
   */
  public sendInputVOToKYMW1404(): void {
    if (this.isOpened('KYMW1404')) {
      this.kymw1404Component.setInputVO(this.kymw1400Model.getKYMW1404InputVO(true));
    }
  }

  /**
   * ロック取得処理
   *
   * @private
   * @param {boolean} kymw1406Flg
   * @param {boolean} kymw1409Flg
   * @memberof KYMW1400Component
   */
  private registLockForSendInputVO(kymw1406Flg: boolean, kymw1409Flg: boolean): void {
    if (this.isOpened('KYMW1406') || this.isOpened('KYMW1409')) {
      let pcodeList: Array<any> = new Array<any>();
      if (this.kymw1400Model.selectedKoma != null) {
        pcodeList = this.kymw1400Model.selectedKoma.getPcodeList();
      }
      // 編集可能モードで、コマが選択されている場合、ロックを取得
      if (!this.kymw1400Model.selectedPageViewHelper.kymw1400KomaPageModel.pageLock && this.kymw1400Model.selectedKoma != null) {
        if (pcodeList.length > 0) {
          this.LockUtilForPlanGoods('REGIST'
            , this.txi_OrderCode.selectedOrderCode
            , this.cmb_Medium.selectedMediumType
            , pcodeList
            , () => {
              this.kymw1400Model.pcodeList = pcodeList;
              this.afterLockForSendInputVO(kymw1406Flg, kymw1409Flg, '0');
            }
            , null
            , (param: any, result: any) => {
              this.afterLockForSendInputVO(kymw1406Flg, kymw1409Flg, '1');
              let UserName = '';
              if (result.result.obj.UnlockedInfo.Catalog[0] != null) {
                UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.Catalog[0].UserName) + ']';
              } else if (result.result.obj.UnlockedInfo.Page[0] != null) {
                UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.Page[0].UserName) + ']';
              } else {
                UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.PlanGoods[0].UserName) + ']';
              }
              this.dialogService.openAlertGetMessage('E0141', [UserName]);
            }
            , null
            , false);
        } else {
          this.afterLockForSendInputVO(kymw1406Flg, kymw1409Flg, '0');
        }

      } else {
        this.afterLockForSendInputVO(kymw1406Flg, kymw1409Flg, '1');
      }
    }
  }

  /**
   * ロック取得後処理
   *
   * @private
   * @param {boolean} kymw1406Flg
   * @param {boolean} kymw1409Flg
   * @param {string} editMode
   * @memberof KYMW1400Component
   */
  private afterLockForSendInputVO(kymw1406Flg: boolean, kymw1409Flg: boolean, editMode: string): void {
    if (kymw1406Flg) {
      this.sendInputVOToKYMW1406(editMode);
    }

    if (kymw1409Flg) {
      this.sendInputVOToKYMW1409(editMode);
    }
  }

  /**
   * 商品情報再表示処理（ロック処理）
   *
   * @param {string} editMode
   * @memberof KYMW1400Component
   */
  public sendInputVOToKYMW1406(editMode: string): void {
    if (this.isOpened('KYMW1406')) {
      const vo: KYMW1406InputModel = new KYMW1406InputModel();
      vo.editMode = editMode;
      vo.komaID = 0;				// コマ削除後の再表示に対応する為、コマが選択されている場合のみコマＩＤを設定
      vo.orderCode = this.kymw1400Model.orderCode;
      vo.mediumType = this.kymw1400Model.mediumType;
      // 編集可能モードで、コマが選択されている場合、ロックを取得
      if (this.kymw1400Model.selectedPageViewHelper.page.selectedKoma != null) {
        vo.pcodeList = this.kymw1400Model.selectedKoma.getPcodeList();
        vo.komaID = Number(this.kymw1400Model.selectedPageViewHelper.page.selectedKoma.komaId);
      }

      if (this.kymw1400Model.selectedPageViewHelper.page.selectedKoma != null) {
        let komaFlg = Boolean(false);										// 通常商品フラグ
        let nvalKomaFlg = Boolean(false);									// 1物N価商品フラグ
        let nvalWpKomaFlg = Boolean(false);									// 1物N価Ｗ掲載商品フラグ
        vo.orderGoodsFlgKoma = this.kymw1400Model.selectedKomaOrderGoodsFlg;	// 注文商品区分他レイアウト情報取得
        // 注文商品区分編集
        // コマの商品の注文商品区分を調べて、コマの商品の注文商品区分を確定する
        for (let i = Number(0); vo.orderGoodsFlgKoma.length > i; i++) {
          // 注文商品区分 = 通常商品("01")
          if (vo.orderGoodsFlgKoma[i].OrderGoodsFlg === '01') {
            // 通常商品フラグ  = true
            komaFlg = true;
          } else if (vo.orderGoodsFlgKoma[i].OrderGoodsFlg === '02') {
            // 注文商品区分 = 1物N価商品("02")
            // 1物N価商品フラグ = true
            nvalKomaFlg = true;
          } else if (vo.orderGoodsFlgKoma[i].OrderGoodsFlg === '03') {
            // 注文商品区分 = 1物N価Ｗ掲載商品("03")
            // 1物N価Ｗ掲載商品フラグ = true
            nvalWpKomaFlg = true;
          }
        }
        // コマの注文商品区分を確定
        // "01"：通常商品、"02"：1物N価商品、"03"：1物N価W掲載商品、"99"：通常商品と1物N価W掲載商品のマルチコマ
        // 通常商品フラグのみ「true」
        if ((komaFlg) && (!nvalKomaFlg) && (!nvalWpKomaFlg)) {
          // 注文商品区分 = 通常商品("01")
          vo.orderGoodsFlg = '01';
        } else if ((nvalKomaFlg) && (!komaFlg) && (!nvalWpKomaFlg)) {
          // 1物N価商品フラグ のみ「true」
          // 注文商品区分 = 1物N価商品("02")
          vo.orderGoodsFlg = '02';
        } else if ((nvalWpKomaFlg) && (!komaFlg) && (!nvalKomaFlg)) {
          // 1物N価Ｗ掲載商品フラグのみ「true」
          // 注文商品区分 = 1物N価Ｗ掲載商品("03")
          vo.orderGoodsFlg = '03';
        } else {
          // 上記以外
          // 注文商品区分 = 通常商品といつ注Ｗ掲載のマルチコマ("99")
          vo.orderGoodsFlg = '99';
        }
      }

      this.kymw1406Component.setInputVO(vo);
    }
  }

  /**
   * マーク指示再表示処理（ロック処理）
   *
   * @param {string} editMode
   * @memberof KYMW1400Component
   */
  public sendInputVOToKYMW1409(editMode: string): void {
    if (this.isOpened('KYMW1409')) {
      const vo: KYMW1409InputModel = new KYMW1409InputModel();
      vo.orderCode = this.kymw1400Model.selectedOrderCode;
      vo.coopCode = this.kymw1400Model.selectedCoopCode;
      vo.editMode = editMode;

      // 注文商品区分を設定する
      vo.orderGoodsFlgKoma = this.kymw1400Model.selectedKomaOrderGoodsFlg;	// 注文商品区分他レイアウト情報取得
      let komaFlg = Boolean(false);										// 通常商品フラグ
      let nvalKomaFlg = Boolean(false);										// 1物N価商品フラグ
      let nvalWpKomaFlg = Boolean(false);										// 1物N価Ｗ掲載商品フラグ
      // 注文商品区分編集
      // コマの商品の注文商品区分を調べて、コマの商品の注文商品区分を確定する
      for (let i = Number(0); vo.orderGoodsFlgKoma.length > i; i++) {
        // 注文商品区分 = 通常商品("01")
        if (vo.orderGoodsFlgKoma[i].OrderGoodsFlg === '01') {
          // 通常商品フラグ  = true
          komaFlg = true;
        } else if (vo.orderGoodsFlgKoma[i].OrderGoodsFlg === '02') {
          // 注文商品区分 = 1物N価商品("02")
          // 1物N価商品フラグ = true
          nvalKomaFlg = true;
        } else if (vo.orderGoodsFlgKoma[i].OrderGoodsFlg === '03') {
          // 注文商品区分 = 1物N価Ｗ掲載商品("03")
          // 1物N価Ｗ掲載商品フラグ = true
          nvalWpKomaFlg = true;
        }
      }
      // コマの注文商品区分を確定
      // "01"：通常商品、"02"：1物N価商品、"03"：1物N価W掲載商品、"99"：通常商品と1物N価W掲載商品のマルチコマ
      // 通常商品フラグのみ「true」
      if ((komaFlg) && (!nvalKomaFlg) && (!nvalWpKomaFlg)) {
        // 注文商品区分 = 通常商品("01")
        vo.orderGoodsFlg = '01';
      } else if ((nvalKomaFlg) && (!komaFlg) && (!nvalWpKomaFlg)) {
        // 1物N価商品フラグ のみ「true」
        // 注文商品区分 = 1物N価商品("02")
        vo.orderGoodsFlg = '02';
      } else if ((nvalWpKomaFlg) && (!komaFlg) && (!nvalKomaFlg)) {
        // 1物N価Ｗ掲載商品フラグのみ「true」
        // 注文商品区分 = 1物N価Ｗ掲載商品("03")
        vo.orderGoodsFlg = '03';
      } else {
        // 上記以外
        // 注文商品区分 = 通常商品といつ注Ｗ掲載のマルチコマ("99")
        vo.orderGoodsFlg = '99';
      }
      // 通常注文商品以外の場合
      for (let l = Number(0); vo.orderGoodsFlgKoma.length > l; l++) {
        if (vo.orderGoodsFlgKoma[l].OrderGoodsFlg === '02' || vo.orderGoodsFlgKoma[l].OrderGoodsFlg === '03') {
          // ページ、セクション情報が存在
          if (this.kymw1400Model.selectedPageManage.pageData != null
            && this.kymw1400Model.selectedPageManage.pageData.SectionInfo != null) {
            // セクション情報が1件でもArrayとして扱う
            const sectionInfoList: Array<any> = this.kymw1400Model.selectedPageManage.pageData.SectionInfo;
            // セクション情報数分ループ
            for (let i = Number(0); sectionInfoList.length > i; i++) {
              // コマ情報が存在
              if (sectionInfoList[i].KomaInfo != null) {
                // コマ情報が1件でもArrayとして扱う
                const komaInfoList: Array<any> = sectionInfoList[i].KomaInfo;
                // コマ情報数分ループ
                for (let j = Number(0); komaInfoList.length > j; j++) {
                  // 選択されたコマのコマIDと一致した場合
                  if (komaInfoList[j].KomaID === this.kymw1400Model.selectedKomaId) {
                    // レイアウト情報が存在
                    if (komaInfoList[j].LayoutInfo != null) {
                      // レイアウト情報が1件でもArrayとして扱う
                      const layoutInfoList: Array<any> = komaInfoList[j].LayoutInfo;
                      // レイアウト情報数分ループ
                      for (let k = Number(0); layoutInfoList.length > k; k++) {
                        const nvalInput: NvalInputModel = new NvalInputModel();
                        nvalInput.receiptSOrderCode = layoutInfoList[k].ReceiptSOrderCode;
                        nvalInput.startOrderCode = layoutInfoList[k].StartOrderCode;
                        nvalInput.orderNum6Digits = layoutInfoList[k].OrderNum6Digits;
                        nvalInput.itemCode = layoutInfoList[k].ItemCode;
                        vo.NvalInputList.push(nvalInput);
                      }
                    }
                    break;
                  }
                }
              }
            }
          }
        }
      }

      // 編集可能モードで、コマが選択されている場合、ロックを取得
      if (this.kymw1400Model.selectedPageViewHelper.page.selectedKoma != null
        && this.kymw1400Model.selectedPageManage.pageData != null) {
        vo.pCodeList = this.kymw1400Model.selectedKoma.getPcodeList();
      }

      this.kymw1409Component.setInputVO(vo);
    }
  }

  /**
   * 01.ページ情報取得dispatch
   *
   * @param {String} [pageID=null]
   * @param {Boolean} [unSelectedPageFlg=false]
   * @memberof KYMW1400Component
   */
  public dispatchGetPageEvent(pageID: string = null, unSelectedPageFlg = false): void {
    let vo: PageIDModel = new PageIDModel();
    let model: KYMW1400KomaPageModel = null;

    // 引数にページＩＤが設定されていた場合は引数をキーに設定
    // それ以外は画面上で選択されているページＩＤをキーに設定
    // ※KYMW1403:掲載商品検索でページコンボの再設定が同時に行われコードが取得できない件の対応
    if (pageID == null) {
      vo = this.kymw1400Model.getPageIDVO();
      if (this.cmb_Medium.selectedMediumType != null) {
        vo.mediumType = this.cmb_Medium.selectedMediumType;
      }
    } else {
      vo.pageID = Number(pageID);
      vo.mediumType = this.cmb_Medium.selectedMediumType;
    }
    // 対象が非表示ページの場合
    if (unSelectedPageFlg) {
      model = this.kymw1400Model.unSelectedPageManage;
      this.kymw1400Model.unSelectedPageViewHelper.getPageService.execute(model, vo, null);
    } else {
      model = this.kymw1400Model.selectedPageManage;
      this.kymw1400Model.selectedPageViewHelper.getPageService.execute(model, vo, null);
    }
  }

  /**
   * 02.計画値集計表取得dispatch
   *
   * @param {Boolean} [leftRightDispatchFlg=false] 右左両方取得フラグ
   * @memberof KYMW1400Component
   */
  public dispatchGetPlanSummaryTableEvent(leftRightDispatchFlg = false): void {
    if (leftRightDispatchFlg) {
      // 左
      if (!PlessViewUtilsSub.isEmpty(this.kymw1400Model.leftView.cmb_Coop.selectedCoopCode)) {
        this.kymw1400Model.leftView.getPlanSummaryTableService.execute(
          this.kymw1400Model.leftManage,
          this.kymw1400Model.getPlanSummaryTableVO(1));
      }

      // 右
      if (!PlessViewUtilsSub.isEmpty(this.kymw1400Model.rightView.cmb_Coop.selectedCoopCode)) {
        this.kymw1400Model.rightView.getPlanSummaryTableService.execute(
          this.kymw1400Model.rightManage,
          this.kymw1400Model.getPlanSummaryTableVO(2));
      }
    } else {
      // 選択ページ
      this.kymw1400Model.selectedPageViewHelper.getPlanSummaryTableService.execute(
        this.kymw1400Model.selectedPageManage,
        this.kymw1400Model.getPlanSummaryTableVO());
    }
  }

  /**
   * 企画情報メンテナンス画面起動
   *
   * @memberof KYMW1400Component
   */
  public openPopUpKYMW0900(): void {
    const vo: KYMW0900InputModel = new KYMW0900InputModel();
    const orderGoodsFlg: Array<any> = this.kymw1400Model.selectedKomaOrderGoodsFlg;
    vo.orderCode = this.kymw1400Model.selectedOrderCode;
    if (this.kymw1400Model.selectedKoma != null) {
      for (let i = Number(0); orderGoodsFlg.length > i; i++) {
        vo.pCodeList.push(orderGoodsFlg[i].PCode);
      }
    }
    vo.MediumType = this.kymw1400Model.selectedMediumType;
    if (this.kymw1400Model.selectedKoma != null) {
      // * 0:編集可、1:編集不可(ロック時)
      if (!this.kymw1400Model.selectedPageViewHelper.kymw1400KomaPageModel.pageLock) {
        // 編集可能モードの場合、ロックを取得
        let pcodeList: Array<any> = new Array<any>();
        if (this.kymw1400Model.leftPageSelected) {
          this.kymw1400Model.leftView.page.selectedKoma.goods.pcodeList2 = vo.pCodeList;
          pcodeList = this.kymw1400Model.leftView.page.selectedKoma.goods.pcodeList2;
        } else {
          this.kymw1400Model.rightView.page.selectedKoma.goods.pcodeList2 = vo.pCodeList;
          pcodeList = this.kymw1400Model.rightView.page.selectedKoma.goods.pcodeList2;
        }
        this.LockUtilForPlanGoods('REGIST'
          , this.txi_OrderCode.selectedOrderCode
          , this.cmb_Medium.selectedMediumType
          , pcodeList
          , () => {
            this.kymw1400Model.pcodeList = pcodeList;
            vo.lockInfo = '0';
            this.openPopUpKYMW0900AfterLockProcess(vo);
          }
          , null
          , (param: any, result: any) => {
            vo.lockInfo = '1';
            this.openPopUpKYMW0900AfterLockProcess(vo);
            let UserName = '';
            if (result.result.obj.UnlockedInfo.Catalog[0] != null) {
              UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.Catalog[0].UserName) + ']';
            } else if (result.result.obj.UnlockedInfo.Page[0] != null) {
              UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.Page[0].UserName) + ']';
            } else {
              UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.PlanGoods[0].UserName) + ']';
            }
            this.dialogService.openAlertGetMessage('E0141', [UserName]);
          }
          , null
          , false);
      } else {
        vo.lockInfo = '1';
        this.openPopUpKYMW0900AfterLockProcess(vo);
      }
    }
  }

  /**
   * 企画情報メンテナンス画面起動（ロック処理後）
   *
   * @private
   * @param {KYMW0900InputModel} vo
   * @memberof KYMW1400Component
   */
  private openPopUpKYMW0900AfterLockProcess(vo: KYMW0900InputModel): void {
    const componentRef = this.dialogService.openModal(KYMW0900Component);
    const instance = componentRef.componentInstance as KYMW0900Component;
    vo.UserPermission = this.isPermittedFullControl ? '0': '1';
    instance.setInterfaceParam(vo);
    instance.setKYMW0900Parameter = (outputVO: KYMW0900OutputModel) => this.setKYMW0900Parameter(outputVO);

    // ウィンドウが閉じられる際の処理
    instance.parent = this;
    instance.closeFunction = () => {
      componentRef.close();
      this.releaseAllPlanGoodsLock(true);
    };
  }

  /**
   * 組合員の声選択画面起動
   *
   * @memberof KYMW1400Component
   */
  public openPopUpKYMW0A00(): void {
    const componentRef = this.dialogService.openModal(KYMW0A00Component);
    const instance = componentRef.componentInstance as KYMW0A00Component;
    instance.dispDialog = true;
    instance.parent = this;
    instance.inputVO = this.kymw1400Model.getKYMW0A00InputVO();
    instance.setKYMW0A00Parameter = (outputVO: KYMW0A00OutputModel) => this.setKYMW0A00Parameter(outputVO);
    instance.closeFunction = () => {
      componentRef.close();
    };

  }

  /**
   * ページロック全解除
   *
   * @private
   * @memberof KYMW1400Component
   */
  private releaseAllPageLock(): void {
    if (this.kymw1400Model.leftPageId !== -1) {
      super.LockUtilForPage('RELEASE'
        , this.kymw1400Model.orderCode
        , this.kymw1400Model.mediumType
        , this.kymw1400Model.leftPageId
        , null
        , null
        , null
        , null
        , false);
    }
    if (this.kymw1400Model.rightPageId !== -1) {
      super.LockUtilForPage('RELEASE'
        , this.kymw1400Model.orderCode
        , this.kymw1400Model.mediumType
        , this.kymw1400Model.rightPageId
        , null
        , null
        , null
        , null
        , false);
    }
  }

  /**
   * 企画商品情報ロック全解除
   *
   * @param {boolean} [considerKYMW1406=false]
   * @returns {void}
   * @memberof KYMW1400Component
   */
  public releaseAllPlanGoodsLock(considerKYMW1406 = false): void {
    if (considerKYMW1406 && (this.isOpened('KYMW1406') || this.isOpened('KYMW1409'))) {
      // 商品情報画面または、マーク指示画面が開いているときは、商品企画ロックを削除しない
      return;
    }
    if (this.kymw1400Model.pcodeList.length > 0) {
      this.LockUtilForPlanGoods('RELEASE'
        , this.kymw1400Model.orderCode
        , this.kymw1400Model.mediumType
        , this.kymw1400Model.pcodeList
        , null
        , null
        , null
        , null
        , false);
    }
    this.kymw1400Model.orderCode = this.txi_OrderCode.selectedOrderCode;
    this.kymw1400Model.mediumType = this.cmb_Medium.selectedMediumType;
  }

  /**
   * 『KYMW0800:実績履歴』
   *
   * @param {KYMW0800OutputModel} outputVo
   * @memberof KYMW1400Component
   */
  public setKYMW0800Parameter(outputVo: KYMW0800OutputModel): void {
  }

  /**
   * 『企画情報メンテナンス』
   *
   * @param {KYMW0900OutputModel} outputVo
   * @memberof KYMW1400Component
   */
  public setKYMW0900Parameter(outputVo: KYMW0900OutputModel): void {
    // 掲載候補商品リストを再表示する
    this.kymw1400Model.updateFlg = 3;
    // 企画メンテで変更されたPコード ※実績履歴の再表示で使用
    this.kymw1400Model.reloadPcode = outputVo.pCode;
    // モードレス画面を再表示する
    this.kymw1400Model.kymw0900Flg = true;
    // コマ情報取得要求(/KYMW14/getKoma.xml)をサーバに送信する。
    const vo = this.kymw1400Model.getKomaIDVO('');
    vo.mediumType = this.cmb_Medium.selectedMediumType;

    this.getKomaService.execute(this.kymw1400Model, vo);

    // 計画値集計表（計画点数、金額(千円)、GPR、点単価）を再表示する。
    this.dispatchGetPlanSummaryTableEvent();
    // モードレスでポップアップしている画面を再表示する
    this.kymw1400Model.kymw1400Component.sendInputVOToAllPopupDialog(true, true, true, true, true, true, false);
    this.kymw1400Model.kymw1406Flg = false;
  }

  /**
   * 『KYMW0A00:組合員の声選択』
   *
   * @param {KYMW0A00OutputModel} outputVo
   * @memberof KYMW1400Component
   */
  public setKYMW0A00Parameter(outputVo: KYMW0A00OutputModel): void {
  }

  /**
   * 『KYMW1403:掲載商品検索』
   *
   * @param {KYMW1403OutputModel} outputVo
   * @memberof KYMW1400Component
   */
  public setKYMW1403Parameter(outputVo: KYMW1403OutputModel): void {
    this.txi_OrderCode.setOrderCode(outputVo.orderCode);
    this.txi_OrderCode.selectedOrderCode = outputVo.orderCode;
    this.bindSelectedOrderCode_CHANGEHandler(this.txi_OrderCode.selectedOrderCode);

    setTimeout(() => {
      this.cmb_Medium.setMediumType(outputVo.mediumType);
      this.cmb_Medium.selectedMediumType = outputVo.mediumType;

      this.kymw1400Model.selectedPageViewHelper.cmb_Coop.setCoopCode(outputVo.coopCode);
      this.kymw1400Model.selectedPageViewHelper.cmb_Coop.selectedCoopCode = outputVo.coopCode;

      this.kymw1400Model.leftView.cmb_Page.orderCode = outputVo.orderCode;
      this.kymw1400Model.leftView.cmb_Page.mediumType = outputVo.mediumType;
      this.kymw1400Model.leftView.cmb_Page.selectedPageNum = outputVo.pageNum;

      this.kymw1400Model.rightView.cmb_Page.orderCode = outputVo.orderCode;
      this.kymw1400Model.rightView.cmb_Page.mediumType = outputVo.mediumType;
      this.kymw1400Model.rightView.cmb_Page.selectedPageNum = outputVo.pageNum;

      this.kymw1400Model.selectedPageViewHelper.cmb_Page.coopCode = outputVo.coopCode;
      this.kymw1400Model.selectedPageViewHelper.cmb_Page.setPageId(outputVo.pageId);
      this.kymw1400Model.selectedPageViewHelper.cmb_Page.selectedPageId = outputVo.pageId;
      this.kymw1400Model.selectedPageViewHelper.cmb_Page.selectedPageNum = outputVo.pageNum;

      if (this.kymw1400Model.leftPageSelected === true) {
        this.kymw1400Model.leftPageId = Number(this.pv_PageViewLeft.KYMW1400KomaPageLeftViewHelper.cmb_Page.selectedPageId);
      } else {
        this.kymw1400Model.rightPageId = Number(this.pv_PageViewRight.KYMW1400KomaPageRightViewHelper.cmb_Page.selectedPageId);
      }

      // ページ情報取得要求(/KYMW14/getPage.xml)をサーバに送信する。
      this.dispatchGetPageEvent(outputVo.pageId);

      // 計画値集計表取得要求(/KYMW14/getPlanSummaryTable.xml)をサーバに送信する。
      this.dispatchGetPlanSummaryTableEvent();

      // モードレスでポップアップしている画面を再表示する。
      this.sendInputVOToAllPopupDialog();

      this.kymw1400Model.updateMenuAndButtonEnable();

      this.kymw1400Model.leftView.cmb_Page.orderCode = outputVo.orderCode;
      this.kymw1400Model.leftView.cmb_Page.mediumType = outputVo.mediumType;
      this.kymw1400Model.rightView.cmb_Page.orderCode = outputVo.orderCode;
      this.kymw1400Model.rightView.cmb_Page.mediumType = outputVo.mediumType;
      this.kymw1400Model.selectedPageViewHelper.cmb_Page.coopCode = outputVo.coopCode;
      this.kymw1400Model.selectedPageViewHelper.cmb_Page.setPageId(outputVo.pageId);
      this.kymw1400Model.selectedPageViewHelper.cmb_Page.selectedPageId = outputVo.pageId;
      // this.kymw1400Model.selectedPageManage.pageLockEnable = true;
      this.kymw1400Model.selectedPageManage.pageLockEnable =
        this.kymw1400Model.funcPermission === this.sharedModel.FUNC_PERMISSION_FULLCONTROL ? true : false;
      this.kymw1400Model.selectedPageViewHelper.setLockButtonStyle(false);
    });
  }

  /**
   * 『KYMW1404:掲載候補商品リスト』
   *
   * @param {KYMW1404OutputVO} outputVo
   * @returns {void}
   * @memberof KYMW1400Component
   */
  public setKYMW1404Parameter(outputVo: KYMW1404OutPutModel): void {
    if (outputVo.processDiv === 1) {
      // コマ配置
      // 「ページレイアウト」の空き領域チェックを行う
      if (!this.kymw1400Model.selectedPage.addNewGoodsKoma(outputVo.goodsData)) {
        this.dialogService.openAlertGetMessage('E0155');
      }
    } else if (outputVo.processDiv === 2) {
      if (PlessViewUtilsSub.isEmpty(this.kymw1400Model.selectedKomaId)) {
        return;
      }

      // アクティブなコマに配置
      const vo = this.kymw1400Model.getRegistGoodsVO(outputVo.goodsData);
      this.registGoodsService.execute(
        this.kymw1400Model,
        vo,
        outputVo.pcode,
        (pCodeList) => {
          this.setKYMW1404ParameterSuccess2(pCodeList);
        });
    }
    // コマ配置、アクティブなコマに配置、ドラッグ＆ドロップ完了時の
    // 掲載候補リスト画面で選択された注文商品区分をコマ割のManageに取得する。
    if (outputVo.goodsData != null && outputVo.goodsData.length > 0) {
      this.kymw1400Model.kymw1404OrderGoodsFlg = outputVo.goodsData[0].orderGoodsFlg;
    }
  }

  /**
   * コマ配置完了イベント
   *
   * @param {Array<string>} pCodeList Pコードリスト
   * @memberof KYMW1400Component
   */
  public setKYMW1404ParameterSuccess1(pCodeList: Array<string>): void {
    // 掲載候補商品リストを再検索
    this.sendInputVOToKYMW1404();
  }

  /**
   * アクティブなコマに配置完了イベント
   *
   * @param {Array<string>} pCodeList Pコードリスト
   * @memberof KYMW1400Component
   */
  public setKYMW1404ParameterSuccess2(pCodeList: Array<string>): void {
    // 掲載候補商品リストを再検索
    this.sendInputVOToKYMW1404();
  }

  /**
   * 『KYMW1406:商品情報』
   *
   * @param {KYMW1406OutputModel} outputVo
   * @memberof KYMW1400Component
   */
  public setKYMW1406Parameter(outputVo: KYMW1406OutputModel): void {
    // 更新フラグを設定する
    this.kymw1400Model.updateFlg = outputVo.updateFlg;
    // モードレス画面を再表示する
    this.kymw1400Model.kymw1406Flg = true;
    // コマ情報取得要求(/KYMW14/getKoma.xml)をサーバに送信する。
    const vo = this.kymw1400Model.getKomaIDVO('');
    vo.mediumType = this.cmb_Medium.selectedMediumType;
    this.getKomaService.execute(this.kymw1400Model, vo);

    // 計画値集計表取得要求(/KYMW14/getPlanSummaryTable.xml)をサーバに送信する。
    this.dispatchGetPlanSummaryTableEvent();

    // モードレスでポップアップしている画面を再表示する
    this.kymw1400Model.kymw1400Component.sendInputVOToAllPopupDialog(true, false);
    this.kymw1400Model.kymw1406Flg = false;
  }

  /**
   * 『KYMW1407:使用画像指示』
   *
   * @memberof KYMW1400Component
   */
  public setKYMW1407Parameter(): void {
    // コマ情報取得要求(/KYMW14/getKoma.xml)をサーバに送信する。
    const vo = this.kymw1400Model.getKomaIDVO('');
    this.getKomaService.execute(this.kymw1400Model, vo);
  }

  /**
   * 『KYMW1409:マーク指示』
   *
   * @param {KYMW1409OutputModel} outputVo
   * @memberof KYMW1400Component
   */
  public setKYMW1409Parameter(outputVo: KYMW1409OutputModel): void {
  }

  /**
   * 子モーダレスのコンテキストメニューを閉じるメソッド
   *
   * @private
   * @memberof KYMW1400Component
   */
  private modelessContextmenuClose() {
    if (this.kymw0800Component !== null) {
      this.kymw0800Component.contextMenu.hide();
    }
    if (this.kymw1403Component !== null) {
      this.kymw1403Component.contextMenu.hide();
    }
    if (this.kymw1404Component !== null) {
      this.kymw1404Component.contextMenu.hide();
    }
    if (this.kymw1406Component !== null) {
      this.kymw1406Component.contextMenu.hide();
    }
    if (this.kymw1407Component !== null) {
      this.kymw1407Component.useImageMenu.hide();
      this.kymw1407Component.goodsImageMenu.hide();
      this.kymw1407Component.useHistoryMenu.hide();
      this.kymw1407Component.searchImageMenu.hide();
    }
  }

  public openKYMW1422() {
    const componentRef = this.dialogService.openModal(KYMW1422Component);
    const instance = componentRef.componentInstance as KYMW1422Component;
    instance.parent = this;
    instance.input = {
      orderCode: this.kymw1400Model.orderCode,
      mediumType: this.kymw1400Model.mediumType,
      coopCode: this.kymw1400Model.selectedCoopCode,
      komaId: this.kymw1400Model.selectedKomaId,
      pageNum: this.kymw1400Model.selectedPageNum,
      pageInfo: this.kymw1400Model.selectedPageInfo
    };
    instance.setKYMW1422Parameter = (komaIds) => {
      // W掲載元を変更したコマを再描画する
      this.updateKomas(komaIds);
      // 選択されていないページはページを再描画することでW掲載元の変更を反映(できたらコマだけ再描画したい)
      this.reloadUnselectedPage();
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  private updateKomas(komaIds: string[]) {
    const noDupllicatedKomaIds = [...new Set(komaIds)];
    noDupllicatedKomaIds.forEach(komaId => {
      const vo = this.kymw1400Model.getKomaIDVO(komaId);
      this.getKomaService.execute(this.kymw1400Model, vo);
    });
  }
  private reloadUnselectedPage() {
    if (this.kymw1400Model.leftPageSelected) {
      this.kymw1400Model.leftPageSelected = false;
      if (this.kymw1400Model.rightView.kymw1400KomaPageModel.reloadEnable) {
        this.kymw1400Model.rightView.reloadPageInfo();
      }
      this.kymw1400Model.leftPageSelected = true;
    } else {
      this.kymw1400Model.leftPageSelected = true;
      if (this.kymw1400Model.leftView.kymw1400KomaPageModel.reloadEnable) {
        this.kymw1400Model.leftView.reloadPageInfo();
      }
      this.kymw1400Model.leftPageSelected = false;
    }
  }

}
